import React from 'react';
import {graphql} from 'gatsby';

import Header from '../components/Header/Header';
import SectionWrapper from '../components/SectionWrapper/SectionWrapper';
import SEO from '../components/seo';

const DjNaWesele = ({data}) => {

    const djMatson = data.djmatson.childImageSharp.fluid;
    const djWorek = data.djworek.childImageSharp.fluid;
    const bgimage = data.djebg.childImageSharp.fluid;
    
    const titleText = "DJ na wesele.";
    const paragraphText = `Doskonale dobrany DJ na wesele jest gwarantem niezapomnianej uroczystośći weselnej. Nasi profesjonalni weselni Dj’e potrafią "wyczuć"
    potrzeby gości.`; 
  
    const content = [
      {
        title: "DJ Matson",
        text: "Dj Matson pracuje w branży od 15 lat. Gra zarówno na uroczystościach rodzinnych, eventach firmowych jak i samodzielne koncerty klubowe. Spokojne usposobienie, wysoka kultura osobista i potężna wiedza na temat rynku muzycznego sprawia, że jest doskonałym wyborem na Państwa wesele. Dynamika jego playlist oraz wyczucie sprawiają, że goście zawsze są zadowoleni z jego oprawy muzycznej na weselu.",
        image: djMatson,
        alt: "DJ Matson",
        link: "https://vimeo.com/388070521",
        target: "yes"
      },
      {
        title: "DJ Worek", 
        text: "DJ Worek. Doświadczony, przezabawny, szalony w swoich żartach i usposobieniu artysta disc jokey. Uwielbia grać i sam mówi, że rozgrzeje do zabawy zarówno emerytów jak i młodych wymagających słuchaczy. Doskonały muzyk na wesele. Jego playlsity są zróżnicowane, dobrze zbudowane, a styl prowadzenia wesela wesoły, spontaniczny i szalony.",
        image: djWorek,
        alt: "DJ Worek",
        link: "https://vimeo.com/292404245",
        target: "yes"
      },
    ];

    return (
        <>  
            <SEO title="DJ na wesele"/>
            <Header link={bgimage}/>
            <SectionWrapper content={content} text={paragraphText} title={titleText} resize="yes"/>
        </>
    )
};

export const query = graphql`
  {
    djmatson: file(name: {eq: "djmatson1"}) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    djworek: file(name: {eq: "djmario1"}) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    djebg: file(name: {eq: "Djebg"}) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;

export default DjNaWesele